import { render, staticRenderFns } from "./PresentLevelsStandardView.vue?vue&type=template&id=54b27020&scoped=true"
import script from "./PresentLevelsStandardView.vue?vue&type=script&lang=js"
export * from "./PresentLevelsStandardView.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsStandardView.vue?vue&type=style&index=0&id=54b27020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b27020",
  null
  
)

export default component.exports